import { render, staticRenderFns } from "./UpdateEvent.vue?vue&type=template&id=2191dd24&"
import script from "./UpdateEvent.vue?vue&type=script&lang=js&"
export * from "./UpdateEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports